import axios from "axios";
import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;
const GET_DATOS_GRUPO_L = `${API_URL}/concursos/obtenerDatosGrupoL`;
const GET_DATOS_GRUPO_F = `${API_URL}/concursos/obtenerDatosGrupoF`;
const GET_SOLICITUD_ID = `${API_URL}/concursos/anexoI1/obtenerSolicitudPorCod`;
export async function getDatosGrupoL() {
  return await axios({
    method: "GET",
    url: GET_DATOS_GRUPO_L,
  })
    .then((response) => {
      return response.data
    })
    .catch(
      (response) =>
        (response.data = "Error: Fallo los datos del grupo L")
    );
}
export async function getDatosGrupoF() {
  return await axios({
    method: "GET",
    url: GET_DATOS_GRUPO_F,
  })
    .then((response) => {
      return response.data
    })
    .catch(
      (response) =>
        (response.data = "Error: Fallo los datos del grupo F")
    );
}

export async function getSolicitudPorCodAnexoI1(xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_SOLICITUD_ID}/${xSolicitud}`,
  })
    .then((response) => {
      return response.data
    })
    .catch(
      (response) =>
        (response.data = "Error: Fallo los datos del grupo F")
    );
}